<div
  *transloco="let t"
  id="star-rating-container"
  class="flex items-center gap-1"
  role="radiogroup"
  [attr.aria-label]="t('commonAriaStarRating')"
  (mouseleave)="onStarLeave()"
>
  @for (star of stars; track star) {
    <button
      type="button"
      [id]="'star-rating-' + star"
      class="border-none bg-transparent p-0 transition-transform duration-150 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-ld-primary"
      [class]="readonly() ? 'cursor-default' : 'cursor-pointer hover:scale-110'"
      [attr.aria-label]="getStarAriaLabel(star)"
      [attr.aria-checked]="star === value()"
      role="radio"
      [disabled]="readonly()"
      (click)="onStarClick(star)"
      (mouseenter)="onStarHover(star)"
    >
      <mat-icon
        [id]="'star-icon-' + star"
        [class]="getSizeClass()"
        [class.text-amber-400]="isStarFilled(star)"
        [class.text-gray-300]="!isStarFilled(star)"
      >
        {{ getStarIcon(star) }}
      </mat-icon>
    </button>
  }
</div>
